import { Button, Text, Modal, IconButton } from '@ltvco/refresh-lib/theme';
import { Close } from '@mui/icons-material';

export interface ModalProps {
  open: boolean;
  handleClose: () => void;
  customTitle?: JSX.Element;
  description?: string | JSX.Element;
  returnButtonText?: string;
}

export const CustomModal = ({
  open,
  handleClose,
  customTitle,
  description,
  returnButtonText,
}: ModalProps) => {
  return (
    <Modal
      open={open}
      hasCloseIcon={false}
      disableScrollLock
      data-testid="custom-modal"
      sx={{
        '.MuiDialog-paper': {
          width: '480px',
        },
      }}
      onClose={handleClose}
      id="custom-modal"
    >
      {customTitle}
      <Text variant="body2" m="1rem 0" textAlign="center">
        {description}
      </Text>
      <Button
        variant="contained"
        sx={{ display: 'flex', m: '2rem auto 0' }}
        onClick={handleClose}
      >
        {returnButtonText}
      </Button>
      <IconButton
        sx={{
          position: 'absolute',
          top: '5px',
          right: '5px',
        }}
        onClick={handleClose}
      >
        <Close sx={{ fontSize: '24px' }} />
      </IconButton>
    </Modal>
  );
};
